import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

// Document Icon
export const DocumentIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M429 102.61H446" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M446 100.28V107.43C445.97 110.28 445.19 111 442.22 111H432.78C429.76 111 429 110.25 429 107.27V100.28C429 97.5798 429.63 96.7098 432 96.5698C432.24 96.5598 432.5 96.5498 432.78 96.5498H442.22C445.24 96.5498 446 97.2998 446 100.28Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M449 96.73V103.72C449 106.42 448.37 107.29 446 107.43V100.28C446 97.3 445.24 96.55 442.22 96.55H432.78C432.5 96.55 432.24 96.56 432 96.57C432.03 93.72 432.81 93 435.78 93H445.22C448.24 93 449 93.75 449 96.73Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M432.25 107.81H433.97" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M436.11 107.81H439.55" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Calendar Icon
export const CalendarIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 14, 
  color = "currentColor" 
}) => (
  <svg
    width={size} 
    height={size} 
    className={className}
    viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.25 4.08333V3.64583C12.25 2.6005 11.3995 1.75 10.3542 1.75H3.64583C2.6005 1.75 1.75 2.6005 1.75 3.64583V4.08333H12.25ZM1.75 4.95833V10.3542C1.75 11.3995 2.6005 12.25 3.64583 12.25H10.3542C11.3995 12.25 12.25 11.3995 12.25 10.3542V4.95833H1.75ZM4.52083 10.5C4.11804 10.5 3.79167 10.1736 3.79167 9.77083C3.79167 9.36804 4.11804 9.04167 4.52083 9.04167C4.92362 9.04167 5.25 9.36804 5.25 9.77083C5.25 10.1736 4.92362 10.5 4.52083 10.5ZM4.52083 7.875C4.11804 7.875 3.79167 7.54862 3.79167 7.14583C3.79167 6.74304 4.11804 6.41667 4.52083 6.41667C4.92362 6.41667 5.25 6.74304 5.25 7.14583C5.25 7.54862 4.92362 7.875 4.52083 7.875ZM7 10.5C6.59721 10.5 6.27083 10.1736 6.27083 9.77083C6.27083 9.36804 6.59721 9.04167 7 9.04167C7.40279 9.04167 7.72917 9.36804 7.72917 9.77083C7.72917 10.1736 7.40279 10.5 7 10.5ZM7 7.875C6.59721 7.875 6.27083 7.54862 6.27083 7.14583C6.27083 6.74304 6.59721 6.41667 7 6.41667C7.40279 6.41667 7.72917 6.74304 7.72917 7.14583C7.72917 7.54862 7.40279 7.875 7 7.875ZM9.47917 7.875C9.07637 7.875 8.75 7.54862 8.75 7.14583C8.75 6.74304 9.07637 6.41667 9.47917 6.41667C9.88196 6.41667 10.2083 6.74304 10.2083 7.14583C10.2083 7.54862 9.88196 7.875 9.47917 7.875Z" fill="#71717A"/>
  </svg>
);

// Folder Icon
export const FolderIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M353 112H359C364 112 366 110 366 105V99C366 94 364 92 359 92H353C348 92 346 94 346 99V105C346 110 348 112 353 112Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M359.75 99H352.25" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M359.75 105H352.25" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Lock Icon
export const LockIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M383.3 108.04V106.88C381 105.49 379.11 102.78 379.11 99.9002C379.11 94.9502 383.66 91.0702 388.8 92.1902C391.06 92.6902 393.04 94.1902 394.07 96.2602C396.16 100.46 393.96 104.92 390.73 106.87V108.03C390.73 108.32 390.84 108.99 389.77 108.99H384.26C383.16 109 383.3 108.57 383.3 108.04Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M383.5 112C385.79 111.35 388.21 111.35 390.5 112" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Mail Icon
export const MailIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M407.73 109.7C408.55 108.82 409.8 108.89 410.52 109.85L411.53 111.2C412.34 112.27 413.65 112.27 414.46 111.2L415.47 109.85C416.19 108.89 417.44 108.82 418.26 109.7C420.04 111.6 421.49 110.97 421.49 108.31V97.04C421.5 93.01 420.56 92 416.78 92H409.22C405.44 92 404.5 93.01 404.5 97.04V108.3C404.5 110.97 405.96 111.59 407.73 109.7Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M409.096 101H409.105" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M411.898 101H417.398" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M409.096 97H409.105" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M411.898 97H417.398" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Download Icon
export const DownloadIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M469 101.15H463" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M458 101.15V96.5298C458 94.4898 459.65 92.8398 461.69 92.8398H467.31C469.35 92.8398 471 94.1098 471 96.1498" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M473.48 102.2C472.98 102.68 472.74 103.42 472.94 104.18C473.19 105.11 474.11 105.7 475.07 105.7H476V107.15C476 109.36 474.21 111.15 472 111.15H462C459.79 111.15 458 109.36 458 107.15V100.15C458 97.9399 459.79 96.1499 462 96.1499H472C474.2 96.1499 476 97.9499 476 100.15V101.6H474.92C474.36 101.6 473.85 101.82 473.48 102.2Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M478 102.62V104.68C478 105.24 477.54 105.7 476.97 105.7H475.04C473.96 105.7 472.97 104.91 472.88 103.83C472.82 103.2 473.06 102.61 473.48 102.2C473.85 101.82 474.36 101.6 474.92 101.6H476.97C477.54 101.6 478 102.06 478 102.62Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Heart Icon
export const HeartIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
  color = "currentColor"
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M497 105C498.657 105 500 103.657 500 102C500 100.343 498.657 99 497 99C495.343 99 494 100.343 494 102C494 103.657 495.343 105 497 105Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M487 102.88V101.12C487 100.08 487.85 99.2199 488.9 99.2199C490.71 99.2199 491.45 97.9399 490.54 96.3699C490.02 95.4699 490.33 94.2999 491.24 93.7799L492.97 92.7899C493.76 92.3199 494.78 92.5999 495.25 93.3899L495.36 93.5799C496.26 95.1499 497.74 95.1499 498.65 93.5799L498.76 93.3899C499.23 92.5999 500.25 92.3199 501.04 92.7899L502.77 93.7799C503.68 94.2999 503.99 95.4699 503.47 96.3699C502.56 97.9399 503.3 99.2199 505.11 99.2199C506.15 99.2199 507.01 100.07 507.01 101.12V102.88C507.01 103.92 506.16 104.78 505.11 104.78C503.3 104.78 502.56 106.06 503.47 107.63C503.99 108.54 503.68 109.7 502.77 110.22L501.04 111.21C500.25 111.68 499.23 111.4 498.76 110.61L498.65 110.42C497.75 108.85 496.27 108.85 495.36 110.42L495.25 110.61C494.78 111.4 493.76 111.68 492.97 111.21L491.24 110.22C490.33 109.7 490.02 108.53 490.54 107.63C491.45 106.06 490.71 104.78 488.9 104.78C487.85 104.78 487 103.92 487 102.88Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Users Group Icon
export const UsersGroupIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
  color = "currentColor"
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 3.01001C16.8395 3.20101 18.2176 4.76201 18.2176 6.62601C18.2176 8.45201 16.9103 9.99001 15.1195 10.237"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 19C3 15.134 5.79086 12 9.5 12C13.2091 12 16 15.134 16 19"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9998 19C18.9998 17.28 18.3998 15.7 17.3998 14.49C17.1298 14.18 16.8298 13.9 16.4998 13.65"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Chat Icon
export const ChatIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
  color = "currentColor"
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 8H17M7 13H13"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Check Circle Icon
export const CheckCircleIcon: React.FC<IconProps> = ({
  className = "",
  size = 24,
  color = "currentColor"
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 12L10.58 14.83L16.25 9.17"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Phone Icon
export const PhoneIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M292 130H293.74C294.82 130 295.67 130.93 295.58 132L294.75 141.96C294.61 143.59 295.9 144.99 297.54 144.99H308.19C309.63 144.99 310.89 143.81 311 142.38L311.54 134.88C311.66 133.22 310.4 131.87 308.73 131.87H295.82" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M306.25 150C306.94 150 307.5 149.44 307.5 148.75C307.5 148.06 306.94 147.5 306.25 147.5C305.56 147.5 305 148.06 305 148.75C305 149.44 305.56 150 306.25 150Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M298.25 150C298.94 150 299.5 149.44 299.5 148.75C299.5 148.06 298.94 147.5 298.25 147.5C297.56 147.5 297 148.06 297 148.75C297 149.44 297.56 150 298.25 150Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M299 136H311" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Volume Icon
export const VolumeIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  color = "currentColor" 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    className={className}
  >
    <path 
      d="M329.09 139.28H332.18V146.48C332.18 148.16 333.09 148.5 334.2 147.24L341.77 138.64C342.7 137.59 342.31 136.72 340.9 136.72H337.81V129.52C337.81 127.84 336.9 127.5 335.79 128.76L328.22 137.36C327.3 138.42 327.69 139.28 329.09 139.28Z" 
      stroke={color} 
      strokeWidth="1.5" 
      strokeMiterlimit="10" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
); 

export const DashboardBlockCreatorIcon: React.FC<IconProps> = ({ 
  className = "", 
  size = 24, 
  style
}) => (
  <svg width="431" style={style} height="288" className={className} viewBox="0 0 431 288" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_56180_24770)">
    <g filter="url(#filter0_f_56180_24770)">
    <rect x="-10" y="-3" width="475" height="380" fill="url(#paint0_linear_56180_24770)"/>
    <rect x="-10" y="-3" width="475" height="380" fill="url(#paint1_linear_56180_24770)"/>
    </g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M297.788 200.871L297.307 203.079H324.052V298.857C324.258 332.669 296 353.784 261.073 343.226C237.903 336.188 231.44 318.178 230.478 296.925C229.79 280.433 230.065 263.733 230.478 246.965C230.615 241.79 230.684 236.546 230.753 231.371L184 309.621C195.551 417.337 366.061 415.957 370.805 302.238V202.113H397C397 200.94 395.969 199.767 395.075 198.732C394.869 198.456 394.594 198.249 394.456 198.042C387.581 189.899 379.949 182.102 372.317 174.304C364.548 166.369 356.779 158.364 349.766 150.084C347.566 147.738 345.778 149.67 344.128 151.464C343.853 151.74 343.647 152.016 343.372 152.223C335.74 159.813 328.59 167.749 321.439 175.753C313.739 184.31 306.107 192.866 297.857 200.94L297.788 200.871Z" fill="url(#paint2_linear_56180_24770)" fill-opacity="0.8"/>
    <path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M205.295 219.964L203.856 226.561H283.841V512.697C284.458 613.71 199.949 676.792 95.4963 645.251C26.2035 624.224 6.87558 570.419 3.99695 506.925C1.94078 457.655 2.76326 407.766 3.99695 357.672C4.40819 342.211 4.6136 326.543 4.81921 311.082L-135 544.856C-100.456 866.656 409.473 862.533 423.66 522.798V223.674H502C502 220.17 498.916 216.665 496.243 213.573C495.626 212.749 494.804 212.13 494.392 211.512C473.831 187.186 451.007 163.891 428.184 140.596C404.949 116.889 381.714 92.9755 360.742 68.2375C354.162 61.2284 348.816 67.0006 343.881 72.3605C343.058 73.1851 342.442 74.0094 341.619 74.6279C318.796 97.3043 297.412 121.012 276.027 144.925C252.998 170.488 230.175 196.05 205.501 220.17L205.295 219.964Z" fill="url(#paint3_linear_56180_24770)" fill-opacity="0.8"/>
    <path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M-24.7496 341.052L-28.4641 358.084H177.965V1096.77C179.557 1357.54 -38.5464 1520.4 -308.124 1438.97C-486.958 1384.69 -536.841 1245.78 -544.27 1081.87C-549.577 954.674 -547.454 825.882 -544.27 696.559C-543.209 656.644 -542.679 616.198 -542.148 576.284L-903 1179.79C-813.848 2010.55 502.201 1999.9 538.817 1122.85V350.632H741C741 341.585 733.04 332.538 726.141 324.555C724.549 322.426 722.427 320.83 721.366 319.233C668.299 256.434 609.395 196.295 550.491 136.157C490.526 74.9551 430.561 13.2213 376.433 -50.6421C359.452 -68.7367 345.655 -53.8353 332.919 -39.9982C330.796 -37.8694 329.204 -35.7414 327.081 -34.1448C268.178 24.3966 212.988 85.5995 157.799 147.334C98.3647 213.326 39.4613 279.318 -24.2185 341.585L-24.7496 341.052Z" fill="url(#paint4_linear_56180_24770)" fill-opacity="0.8"/>
    </g>
    <defs>
    <filter id="filter0_f_56180_24770" x="-34" y="-27" width="523" height="428" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
    <feGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_56180_24770"/>
    </filter>
    <linearGradient id="paint0_linear_56180_24770" x1="-10" y1="-227" x2="220" y2="289" gradientUnits="userSpaceOnUse">
    <stop stop-color="#8700EE" stop-opacity="0.8"/>
    <stop offset="1" stop-color="#006FEE"/>
    </linearGradient>
    <linearGradient id="paint1_linear_56180_24770" x1="414.5" y1="315.5" x2="44.6687" y2="95.1875" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D1BAFA"/>
    <stop offset="0.586221" stop-color="#9675CE"/>
    <stop offset="0.913461" stop-color="#A165EF"/>
    </linearGradient>
    <linearGradient id="paint2_linear_56180_24770" x1="385.458" y1="149" x2="275.628" y2="268.659" gradientUnits="userSpaceOnUse">
    <stop stop-color="white"/>
    <stop offset="1" stop-color="white" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint3_linear_56180_24770" x1="467.483" y1="65" x2="139.396" y2="422.821" gradientUnits="userSpaceOnUse">
    <stop stop-color="white"/>
    <stop offset="1" stop-color="white" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint4_linear_56180_24770" x1="651.916" y1="-59" x2="-195.091" y2="864.505" gradientUnits="userSpaceOnUse">
    <stop stop-color="white"/>
    <stop offset="1" stop-color="white" stop-opacity="0"/>
    </linearGradient>
    <clipPath id="clip0_56180_24770">
    <rect width="431" height="288" fill="white"/>
    </clipPath>
    </defs>
  </svg>
)